import React from 'react';
import { FaLinkedin, FaFacebook, FaTwitter } from 'react-icons/fa';
import './Leader.css';

const leadersData = [
  {
    name: 'Dr. Sukanta',
    title: 'CEO (U.K)',
    image: 'dr-sukanta.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
  {
    name: 'Gareth',
    title: 'Business Development Advisor',
    image: 'gareth.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
  {
    name: 'Kharabela',
    title: 'Director – India',
    image: 'kharabela.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
  {
    name: 'Subra',
    title: 'Technology Head',
    image: 'subra.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
  {
    name: 'Ramanuj',
    title: 'Product Architect',
    image: 'ramanuj.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
  {
    name: 'Peekay',
    title: 'Chief Strategist',
    image: 'peekay.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
  {
    name: 'Ash',
    title: 'Marketing Head',
    image: 'Ash.png',
    linkedin: '#',
    facebook: '#',
    twitter: '#',
  },
];

const Leaders = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center text-primary mb-2">Inovaantage</h2>
      <h3 className="text-center mb-4">Our Leaders</h3>

      <div className="row">
        {leadersData.map((leader, index) => (
          <div key={index} className="col-sm-6 col-md-4 mb-4">
            <div className="card h-100 shadow border-0">
              <img
                src={leader.image}
                alt={leader.name}
                className="card-img-top"
                style={{ height: '320px', objectFit: 'contain' }}
              />
              <div className="card-body text-center">
                <p className="mb-1 text-muted">{leader.title}</p>
                <h5 className="card-title mb-2">{leader.name}</h5>
                <div className="social-icons d-flex justify-content-center gap-3">
                  <a href={leader.linkedin} target="_blank" rel="noopener noreferrer">
                    <FaLinkedin size={20} color="#0A66C2" />
                  </a>
                  <a href={leader.facebook} target="_blank" rel="noopener noreferrer">
                    <FaFacebook size={20} color="#1877F2" />
                  </a>
                  <a href={leader.twitter} target="_blank" rel="noopener noreferrer">
                    <FaTwitter size={20} color="#1DA1F2" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leaders;
